var $2e9df5c45e97c2b7$exports = {};
$2e9df5c45e97c2b7$exports = {
    "pending": `\u{432} \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{438}`
};


export {$2e9df5c45e97c2b7$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
